import {
  BillingAccount,
  Invoice,
  PublicInvoice,
  ThirdPartyAgreement,
} from 'interfaces/ApiTypeAliases';
import { InvoiceDetails } from 'interfaces/odinTypes';
import {
  RedeemCreditNoteDTO,
  RedeemCreditNoteDTOResponse,
  ValidateCreditNoteDTOResponse,
} from 'pages/PublicCreditNote/api';
import { PayingForProduct } from 'utils/format';

export const billingAccounts: BillingAccount[] = [
  {
    accountNumber: 204392007,
    paymentMethod: {
      type: 'ManualPayment',
    },
    userHandlesPayments: true,
    billingFrequency: 'Quarterly',
    communicationSettings: {
      emailAddress: 'test@nuuday.dk',
      canBeChanged: true,
      type: 'BillingViaEmail',
    },
    notificationSettings: {
      emailAddress: 'test@nuuday.dk',
      phoneNumber: '88888888',
      type: 'NotificationViaEmailAndSms',
    },
    affiliations: ['ResidentialSegment'],
    payingFor: [],
    billingAddress: {
      street: 'Hamrandersvej',
      streetNumber: '1',
      city: 'Randers c',
      zipCode: '8900',
      streetCode: '9977',
      floor: '58',
      side: 'MF',
      houseLetter: '',
      apartmentNumber: '',
      municipalityCode: '730',
    },
  },
  {
    accountNumber: 2043920123,
    paymentMethod: {
      creditCard: {
        status: 'Active',
        cardNumberMasked: 'XXXXXXXXXXXX0000',
        cardNumberPrefix: '471110',
        creditCardType: 'Visa',
        expirationDate: '2024-06-29',
        ticketId: null,
      },
      type: 'AutomaticCardPayment',
    },
    userHandlesPayments: true,
    billingFrequency: 'Quarterly',
    communicationSettings: {
      emailAddress: 'letter@nuuday.dk',
      canBeChanged: true,
      type: 'BillingViaLetter',
    },
    notificationSettings: {
      emailAddress: 'letter@nuuday.dk',
      phoneNumber: '88888888',
      type: 'NotificationViaEmailAndSms',
    },
    affiliations: ['ResidentialSegment'],
    payingFor: [],
    billingAddress: {
      street: 'Hamrandersvej',
      streetNumber: '1',
      city: 'Randers c',
      zipCode: '8900',
      streetCode: '9977',
      floor: '58',
      side: 'MF',
      houseLetter: '',
      apartmentNumber: '',
      municipalityCode: '730',
    },
  },
  {
    accountNumber: 204808789,
    paymentMethod: {
      agreementId: 'e2e69824-adfd-4910-9222-13421a7807f0',
      type: 'MobilePayPayment',
    },
    userHandlesPayments: true,
    billingFrequency: 'Quarterly',
    communicationSettings: {
      emailAddress: 'test@nuuday.dk',
      canBeChanged: true,
      type: 'BillingViaEmail',
    },
    notificationSettings: {
      emailAddress: 'test@nuuday.dk',
      phoneNumber: '88888888',
      type: 'NotificationViaEmailAndSms',
    },
    affiliations: ['ResidentialSegment'],
    payingFor: [],
    billingAddress: {
      street: 'Pileparken',
      streetNumber: '74',
      city: 'Brøndby',
      zipCode: '2605',
      streetCode: '494',
      floor: '',
      side: '',
      houseLetter: '',
      apartmentNumber: '',
      municipalityCode: '153',
    },
  },
  {
    accountNumber: 650514181,
    paymentMethod: {
      creditCard: {
        status: 'Active',
        cardNumberMasked: 'XXXXXXXXXXXX0000',
        cardNumberPrefix: '471110',
        creditCardType: 'Visa',
        expirationDate: '2024-06-29',
        ticketId: null,
      },
      type: 'AutomaticCardPayment',
    },
    userHandlesPayments: true,
    billingFrequency: 'Quarterly',
    communicationSettings: {
      emailAddress: 'bij@tdc.dk',
      canBeChanged: false,
      type: 'BillingViaEbox',
    },
    notificationSettings: {
      emailAddress: 'bij@tdc.dk',
      phoneNumber: '51146108',
      type: 'NotificationViaEmailAndSms',
    },
    affiliations: ['ResidentialSegment'],
    payingFor: [],
    billingAddress: {
      street: 'Blichers Alle',
      streetNumber: '3',
      city: 'Esbjerg c',
      zipCode: '6700',
      streetCode: '656',
      floor: '',
      side: '',
      houseLetter: '',
      apartmentNumber: '',
      municipalityCode: '561',
    },
  },
  {
    accountNumber: 204813669,
    paymentMethod: {
      creditCard: {
        status: 'Active',
        cardNumberMasked: 'XXXXXXXXXXXX0000',
        cardNumberPrefix: '471110',
        creditCardType: 'Visa',
        expirationDate: '2024-06-29',
        ticketId: null,
      },
      type: 'AutomaticCardPayment',
    },
    userHandlesPayments: true,
    billingFrequency: 'Quarterly',
    communicationSettings: {
      emailAddress: 'nicho@nuuday.dk',
      canBeChanged: true,
      type: 'BillingViaMitYouSee',
    },
    notificationSettings: {
      emailAddress: 'nicho@nuuday.dk',
      phoneNumber: '22222222',
      type: 'NotificationViaEmailAndSms',
    },
    affiliations: ['ResidentialSegment'],
    payingFor: [],
    billingAddress: {
      street: 'Blichers Alle',
      streetNumber: '3',
      city: 'Esbjerg c',
      zipCode: '6700',
      streetCode: '656',
      floor: '',
      side: '',
      houseLetter: '',
      apartmentNumber: '',
      municipalityCode: '561',
    },
  },
];

export const thirdPartyBillingAccounts: {
  billingAccounts: ThirdPartyAgreement[];
  subscriptions: PayingForProduct[] | null;
} = {
  billingAccounts: [
    {
      accountNumber: 203180677,
      affiliation: 'ConsumerAssociation',
      payingFor: ['FIXED'],
    },
    {
      accountNumber: 2043920123,
      affiliation: 'ResidentialSegment',
      payingFor: ['FIXED'],
    },
    {
      accountNumber: 204808789,
      affiliation: 'BusinessSegment',
      payingFor: ['TV', 'BROADBAND'],
    },
    {
      accountNumber: 204813669,
      affiliation: 'SohoSegment',
      payingFor: ['MOBILE_BROADBAND'],
    },
    {
      accountNumber: 650514181,
      affiliation: 'Union',
      payingFor: ['NETBASIS'],
    },
  ],
  subscriptions: ['BROADBAND'],
};

import { CreditNote } from 'interfaces/ApiTypeAliases';

export const creditNote: CreditNote = {
  status: 'Outstanding',
  method: {
    type: 'NemkontoRefund',
  },
  type: 'CreditNote',
  id: 3351,
  number: 1,
  billingAccountNumber: 204392007,
  totalInclVat: {
    amount: 1571.6,
    currencyCode: 'DKK',
  },
  remainingInclVat: {
    amount: 400.6,
    currencyCode: 'DKK',
  },
  createdAtDate: '2021-03-05T00:00:00',
  lines: [],
  products: ['TV', 'MOBILE'],
};

/** these are made up values - we need a proper one from the backend - they're made for every permutation here: https://wiki.tdc.dk/display/YSS/Statement+states */
const creditNotesData: CreditNote[] = [
  // #region outstanding
  {
    status: 'Outstanding',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 3351,
    number: 1,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Outstanding',
    method: {
      type: 'CreditCardRefund',
    },
    type: 'CreditNote',
    id: 3352,
    number: 2,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Outstanding',
    method: {
      type: 'BankTransferRefund',
    },
    type: 'CreditNote',
    id: 3253,
    number: 3,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },

  // #endregion outstanding

  // #region settled
  {
    status: 'Settled',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 3354,
    number: 4,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Settled',
    method: {
      type: 'CreditCardRefund',
    },
    type: 'CreditNote',
    id: 3355,
    number: 5,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Settled',
    method: {
      type: 'BankTransferRefund',
    },
    type: 'CreditNote',
    id: 3356,
    number: 6,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Settled',
    method: {
      type: 'DeductedInvoiceRefund',
    },
    type: 'CreditNote',
    id: 3357,
    number: 7,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  // #endregion settled

  // #region pending
  {
    status: 'Pending',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 3358,
    number: 8,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Pending',
    method: {
      type: 'CreditCardRefund',
    },
    type: 'CreditNote',
    id: 3359,
    number: 9,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Pending',
    method: {
      type: 'BankTransferRefund',
    },
    type: 'CreditNote',
    id: 3360,
    number: 10,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Pending',
    method: {
      type: 'DeductedInvoiceRefund',
    },
    type: 'CreditNote',
    id: 3361,
    number: 11,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  // #endregion pending

  // #region failed to payout
  {
    status: 'FailedToPayout',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 3362,
    number: 12,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'FailedToPayout',
    method: {
      type: 'CreditCardRefund',
    },
    type: 'CreditNote',
    id: 3363,
    number: 13,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'FailedToPayout',
    method: {
      type: 'BankTransferRefund',
    },
    type: 'CreditNote',
    id: 3364,
    number: 14,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'FailedToPayout',
    method: {
      type: 'DeductedInvoiceRefund',
    },
    type: 'CreditNote',
    id: 3365,
    number: 15,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  // #endregion failed to payout

  // #region not paid out
  {
    status: 'NotPaidOut',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 3366,
    number: 16,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  // #endregion not paid out

  // #region suspended
  {
    status: 'Suspended',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 3367,
    number: 17,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Suspended',
    method: {
      type: 'CreditCardRefund',
    },
    type: 'CreditNote',
    id: 3368,
    number: 18,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Suspended',
    method: {
      type: 'BankTransferRefund',
    },
    type: 'CreditNote',
    id: 3369,
    number: 19,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Suspended',
    method: {
      type: 'DeductedInvoiceRefund',
    },
    type: 'CreditNote',
    id: 3370,
    number: 20,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  // #endregion suspended

  // #region failed can retry
  {
    status: 'FailedCanRetry',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 3371,
    number: 21,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'FailedCanRetry',
    method: {
      type: 'CreditCardRefund',
    },
    type: 'CreditNote',
    id: 3372,
    number: 22,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'FailedCanRetry',
    method: {
      type: 'BankTransferRefund',
    },
    type: 'CreditNote',
    id: 3373,
    number: 23,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'FailedCanRetry',
    method: {
      type: 'DeductedInvoiceRefund',
    },
    type: 'CreditNote',
    id: 3374,
    number: 24,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  // #endregion failed can retry
];

export const creditNotes: CreditNote[] = creditNotesData.map((creditNote, index) => ({
  ...creditNote,
  id: index,
}));

export const creditNotesForStories: CreditNote[] = [
  {
    status: 'Outstanding',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 1,
    number: 1,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Settled',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 4,
    number: 4,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
  {
    status: 'Pending',
    method: {
      type: 'NemkontoRefund',
    },
    type: 'CreditNote',
    id: 8,
    number: 8,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1571.6,
      currencyCode: 'DKK',
    },
    remainingInclVat: {
      amount: 400.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['TV', 'MOBILE'],
  },
];

export const publicInvoice: PublicInvoice = {
  totalInclVat: { amount: 17221.79, currencyCode: 'DKK' },
  status: 'Overdue',
  type: 'PublicInvoice',
  number: 3,
  associatedBillingAccount: { accountNumber: 204044081, hasAutomaticCardPayment: false },
};

const invoicesData: Invoice[] = [
  {
    status: 'Outstanding',
    dueDate: '2020-11-26T00:00:00',
    method: {
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 10,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 731,
    number: 19,
    billingAccountNumber: 204078994,
    totalInclVat: {
      amount: 2319,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-11-26T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticDirectDebitPayment',
    },
    period: {
      month: 10,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 1202,
    number: 16,
    billingAccountNumber: 204145821,
    totalInclVat: {
      amount: 537,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Overdue',
    dueDate: '2019-11-26T00:00:00',
    method: {
      creditCard: {},
      type: 'ConsumerAssociationPayment',
    },
    period: {
      month: 10,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 1017,
    number: 8,
    billingAccountNumber: 204297539,
    totalInclVat: {
      amount: 537,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Suspended',
    dueDate: '2020-10-02T00:00:00',
    method: {
      type: 'MobilePayPayment',
    },
    period: {
      month: 9,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 684,
    number: 5,
    billingAccountNumber: 204045289,
    totalInclVat: {
      amount: 100.02,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  // {
  //   status: 'DeductedViaCreditNote',
  //   dueDate: '2020-09-29T00:00:00',
  //   method: {
  //     creditCard: null,
  //     type: 'ThirdPartyAgentPayment',
  //   },
  //   period: {
  //     month: 9,
  //     year: 2020,
  //     type: 'OneTimeBillingPeriod',
  //   },
  //   type: 'Invoice',
  //   id: 186,
  //   number: 36,
  //   billingAccountNumber: 204391921,
  //   totalInclVat: {
  //     amount: 100.03,
  //     currencyCode: 'DKK',
  //   },
  //   createdAtDate: '2021-03-05T00:00:00',
  //   lines: [],
  //   products: ['BROADBAND', 'TV'],
  // },
  {
    status: 'Settled',
    dueDate: '2020-08-26T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 9,
      year: 2020,
      type: 'MonthlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 237,
    number: 49,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 3901.24,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-08-12T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 7,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 63,
    number: 13,
    billingAccountNumber: 204145821,
    totalInclVat: {
      amount: 537,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-08-11T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 7,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 102,
    number: 2,
    billingAccountNumber: 204045988,
    totalInclVat: {
      amount: 200,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-06-02T00:00:00',
    method: {
      type: 'AutomaticDirectDebitPayment',
    },
    period: {
      month: 5,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 1015,
    number: 6,
    billingAccountNumber: 204297539,
    totalInclVat: {
      amount: 546.75,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-05-12T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 4,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 236,
    number: 48,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-30T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 7,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 730,
    number: 18,
    billingAccountNumber: 204078994,
    totalInclVat: {
      amount: 2397.6,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-30T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 4,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 728,
    number: 16,
    billingAccountNumber: 204078994,
    totalInclVat: {
      amount: 12367.34,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-30T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 4,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 62,
    number: 12,
    billingAccountNumber: 204145821,
    totalInclVat: {
      amount: 537,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Overdue',
    dueDate: '2020-03-30T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 4,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 1014,
    number: 5,
    billingAccountNumber: 204297539,
    totalInclVat: {
      amount: 537,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-13T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 235,
    number: 47,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1764,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-13T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 233,
    number: 45,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 200,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-13T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 36,
    number: 36,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 200,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-13T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 61,
    number: 11,
    billingAccountNumber: 204297539,
    totalInclVat: {
      amount: 6255,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-13T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 1013,
    number: 4,
    billingAccountNumber: 204297539,
    totalInclVat: {
      amount: 6255,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-12T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 231,
    number: 43,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-12T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 173,
    number: 23,
    billingAccountNumber: 204391921,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-12T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 172,
    number: 22,
    billingAccountNumber: 204391921,
    totalInclVat: {
      amount: 1000,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-10T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 234,
    number: 46,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 100,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-10T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 232,
    number: 44,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-09T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 35,
    number: 35,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-09T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 34,
    number: 34,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 1500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-05T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 230,
    number: 42,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-02T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 228,
    number: 40,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 200,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-03-02T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 226,
    number: 38,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 100,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 229,
    number: 41,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 227,
    number: 39,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-27T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 28,
    number: 28,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 300,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-27T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 27,
    number: 27,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 500,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-27T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 21,
    number: 21,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 1000,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-27T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 20,
    number: 20,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 502,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-27T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 1,
      year: 2020,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 16,
    number: 16,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 507,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-24T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 2,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 169,
    number: 19,
    billingAccountNumber: 204391921,
    totalInclVat: {
      amount: 90000,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-02-07T00:00:00',
    method: {
      creditCard: {},
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 10,
      year: 2019,
      type: 'QuarterlyBillingPeriod',
      /** TODO: not representative - just a random value */
      from: '2021-02-25T00:00:00',
      /** TODO: not representative - just a random value */
      to: '2021-05-01T00:00:00',
    },
    type: 'Invoice',
    id: 15,
    number: 15,
    billingAccountNumber: 204391295,
    totalInclVat: {
      amount: 5814.85,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2020-01-31T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 1,
      year: 2020,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 168,
    number: 18,
    billingAccountNumber: 204391921,
    totalInclVat: {
      amount: 85.55,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
];

/** https://wiki.tdc.dk/display/YSS/Statement+states */
const invoicePermutationsData: Invoice[] = [
  //#region outstanding
  {
    status: 'Outstanding',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: null,
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1234567.89,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Outstanding',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Outstanding',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204386275, // 204392007,
    totalInclVat: {
      amount: 100.01,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Outstanding',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticDirectDebitPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'MonthlyBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Outstanding',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'MobilePayPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  //#endregion outstanding
  //#region settled
  {
    status: 'Settled',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: null,
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 123456789.89,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204386275, //204392007,
    totalInclVat: {
      amount: 200.02,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticDirectDebitPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'MobilePayPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Settled',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'DeductedByCredit',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  //#endregion settled
  //#region pending
  {
    status: 'Pending',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticDirectDebitPayment',
    },
    period: null,
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204386275, //204392007,
    totalInclVat: {
      amount: 1234567.89,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Pending',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticDirectDebitPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204386275, //204392007,
    totalInclVat: {
      amount: 300.03,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  //#endregion pending
  //#region overdue
  {
    status: 'Overdue',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: null,
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1234567.89,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Overdue',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Overdue',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204386275, // 204392007,
    totalInclVat: {
      amount: 400.04,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Overdue',
    dueDate: '2019-10-27T00:00:00',
    method: {
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204386275, // 204392007,
    totalInclVat: {
      amount: 444.04,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Overdue',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticDirectDebitPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Overdue',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'MobilePayPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  //#endregion overdue
  //#region suspended
  {
    status: 'Suspended',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: null,
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 1234567.89,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Suspended',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'ManualPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Suspended',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticCardPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204519743, // 204392007,
    totalInclVat: {
      amount: 500.05,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Suspended',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'AutomaticDirectDebitPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  {
    status: 'Suspended',
    dueDate: '2019-12-27T00:00:00',
    method: {
      type: 'MobilePayPayment',
    },
    period: {
      month: 12,
      year: 2019,
      type: 'OneTimeBillingPeriod',
    },
    type: 'Invoice',
    id: 225,
    number: 37,
    billingAccountNumber: 204392007,
    totalInclVat: {
      amount: 188.08,
      currencyCode: 'DKK',
    },
    createdAtDate: '2021-03-05T00:00:00',
    lines: [],
    products: ['BROADBAND', 'TV'],
  },
  //#endregion suspended
];

const invoicePermutations = invoicePermutationsData.map((invoice, index) => ({
  ...invoice,
  id: `mock-invoice-${index.toString()}`,
  number: index + 1,
  createdAtDate: new Date().toUTCString(),
}));

export const invoices = [...invoicePermutations, ...invoicesData];

const invoiceDetailsData: InvoiceDetails[] = [
  {
    price: 8073,
    productName: 'Bredbånd garanteret 50/10, DSL',
    type: 'BRAND',
  },
  {
    price: 2673,
    productName: 'YouSee Bredbåndstelefoni FriTale',
    type: 'BRAND',
  },
  {
    price: 12,
    productName: 'Bredbåndstelefoni',
    type: 'SUBSCRIPTION',
  },
  {
    price: 12,
    productName: 'Bredbåndstelefoni',
    type: 'SUBSCRIPTION',
  },
  {
    price: 12,
    productName: 'Bredbåndstelefoni',
    type: 'SUBSCRIPTION',
  },
  {
    price: 318.03,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 12,
    productName: 'Bredbåndstelefoni',
    type: 'SUBSCRIPTION',
  },
  {
    price: 12,
    productName: 'Bredbåndstelefoni',
    type: 'SUBSCRIPTION',
  },
  {
    price: 65.48,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 299,
    productName: 'Bredbånd 20/2 Mbit',
    type: 'ONETIMEPAYMENT',
  },
  {
    price: 200,
    productName: 'Andet',
    type: 'OTHER',
  },
  {
    price: 357,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 357,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 357,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 318.03,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 357,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 17.77,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 357,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 65.48,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 357,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 387,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 387,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 387,
    productName: 'Fri Tale & 10 GB Basis',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Gebyr for brevpost',
    type: 'SUBSCRIPTION',
  },
  {
    price: 87,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 200,
    productName: 'Rejsedata 200 MB (i 8 Lande)',
    type: 'ONETIMEPAYMENT',
  },
  {
    price: 99,
    productName: 'Datadeling 1 TIL AKTIVERING',
    type: 'ONETIMEPAYMENT',
  },
  {
    price: 99,
    productName: 'Datadeling 1 TIL AKTIVERING',
    type: 'ONETIMEPAYMENT',
  },
  {
    price: 400,
    productName: 'Rejsedata World',
    type: 'ONETIMEPAYMENT',
  },
  {
    price: 299,
    productName: 'Fri Tale / Fri Data',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 299,
    productName: 'Fri Tale / Fri Data',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 299,
    productName: 'Fri Tale / Fri Data',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 299,
    productName: 'Fri Tale / Fri Data',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 299,
    productName: 'Fri Tale / Fri Data',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 299,
    productName: 'Fri Tale / Fri Data',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: -69.35,
    productName: 'Tilbagebetaling',
    type: 'REFUND',
  },
  {
    price: 77.42,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 169,
    productName: 'Fri Tale/ 30 GB',
    type: 'SUBSCRIPTION',
  },
  {
    price: 30,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 169,
    productName: 'Fri Tale/ 30 GB',
    type: 'SUBSCRIPTION',
  },
  {
    price: 30,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 169,
    productName: 'Fri Tale/ 30 GB',
    type: 'SUBSCRIPTION',
  },
  {
    price: 30,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 169,
    productName: 'Fri Tale/ 30 GB',
    type: 'SUBSCRIPTION',
  },
  {
    price: 30,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 169,
    productName: 'Fri Tale/ 30 GB',
    type: 'SUBSCRIPTION',
  },
  {
    price: 30,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
  {
    price: 169,
    productName: 'Fri Tale/ 30 GB',
    type: 'SUBSCRIPTION',
  },
  {
    price: 30,
    productName: 'Datadeling',
    type: 'SUBSCRIPTION',
  },
  {
    price: 100,
    productName: '10 timers tale til 54 lande',
    type: 'SUBSCRIPTION',
  },
];

export const invoiceDetails = invoiceDetailsData.reduce<InvoiceDetails[]>((acc, cur) => {
  // remove duplicates
  if (acc.some((x) => x.productName === cur.productName)) return acc;
  acc.push(cur);
  return acc;
}, []);

export const invoiceDetailsOnlyOnetime = invoiceDetails.filter(
  (x) => x.type === 'BRAND' || x.type === 'SUBSCRIPTION',
);

export const invoiceDetailsOnlySubscriptions = invoiceDetails.filter(
  (x) => !invoiceDetailsOnlyOnetime.includes(x),
);

export const validateCreditNoteResponseMock: ValidateCreditNoteDTOResponse = {
  statusCode: 0,
  creditNote: {
    invoiceNumber: 22,
    accountNumber: 650371291,
    status: 'CreditNoteNotPaid',
    refundedAmount: 15.0,
    originalAmount: 15.0,
  },
};

export const redeemCreditNoteResponseMock: RedeemCreditNoteDTOResponse = {
  invoiceNumber: 22,
};

export const payoutMock: RedeemCreditNoteDTO = {
  accountNumber: 650371291,
  creditNoteNumber: 22,
  securityCode: 24628,
  cpr: '0101004007',
  emailReceipt: 'test@test.dk',
  smsReceipt: '80808080',
};

export const mockInvoice: Invoice = {
  status: 'Outstanding',
  dueDate: '2019-12-27T00:00:00',
  method: { type: 'ManualPayment' },
  period: { month: 12, year: 2019, type: 'OneTimeBillingPeriod' },
  type: 'Invoice',
  id: 1,
  number: 2,
  billingAccountNumber: 204392007,
  totalInclVat: { amount: 188.08, currencyCode: 'DKK' },
  createdAtDate: 'Wed, 26 Oct 2022 12:20:03 GMT',
  lines: [],
  products: ['BROADBAND', 'TV'],
};
